import { LoadingButtonProps as MuiLoadingButtonProps } from '@mui/lab';
import { Button as MuiLoadingButton } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

interface LoadingButtonProps extends MuiLoadingButtonProps { sx?: SxProps<Theme> }

const LoadingButton: FC<LoadingButtonProps> = ({ children, sx = [], ...props }) => {
  return (
    <MuiLoadingButton
      {...props}
      variant='outlined'
      loadingIndicator={<LoadingIndicator thickness={3} size={24} loading={props.loading ?? true}/>}
      sx={[
        {
          borderImage: 'linear-gradient(to right, #931216, #E20B23, #FF8230) 1 !important',
          border: '2px solid',
          letterSpacing: '0.1em',
          fontSize: '14px',
          padding: '10px, 20px',
          fontWeight: 500,
          color: 'black',
          backgroundColor: 'white',
          minWidth: 'fit-content',
          '&:hover': {
            border: '2px solid',
            backgroundColor: 'white'
          },
          '&.Mui-disabled': {
            border: '2px solid'
          }
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}>
      {children}
    </MuiLoadingButton>
  )
}

export default LoadingButton;
